interface Props {
  formData: any;
}
function DetailSectionUserInputs({ formData }: Props) {
  return (
    <div id='user_inputs'>
      <div className='mb-3'>
        <label htmlFor='username' className='form-label'>
          Username
        </label>
        <input
          type='text'
          className='form-control ubbe-input'
          id='username'
          disabled
          autoComplete='new-password'
          value={formData?.username}
        />
      </div>
      <div className='mb-3'>
        <label htmlFor='date_joined' className='form-label'>
          Date Joined
        </label>
        <input
          type='text'
          className='form-control ubbe-input'
          id='date_joined'
          disabled
          placeholder='date'
          autoComplete='new-password'
          value={formData?.date_joined}
        />
      </div>
      <div className='mb-3'>
        <label htmlFor='last_login' className='form-label'>
          Last Login
        </label>
        <input
          type='text'
          className='form-control ubbe-input'
          id='last_login'
          disabled
          placeholder='date'
          autoComplete='new-password'
          value={formData?.last_login}
        />
      </div>
      <div className='mb-3'>
        <label htmlFor='rating' className='form-label'>
          Amount Rated
        </label>
        <input
          type='text'
          className='form-control ubbe-input'
          id='rating'
          disabled
          placeholder='rate'
          autoComplete='new-password'
          value={formData?.rating}
        />
      </div>
      <div className='mb-3'>
        <label htmlFor='shipping' className='form-label'>
          Amount Shipped
        </label>
        <input
          type='text'
          className='form-control ubbe-input'
          id='shipping'
          disabled
          placeholder='ship'
          autoComplete='new-password'
          value={formData?.shipping}
        />
      </div>
    </div>
  );
}

export default DetailSectionUserInputs;
